import type { ToastServiceMethods } from 'primevue/toastservice'
import type { ToastMessageOptions } from 'primevue'

let toastRef: ToastServiceMethods | null = null

export function registerToast(toast: ToastServiceMethods) {
    toastRef = toast
}

export function showToast(options: ToastMessageOptions) {
    toastRef?.add(options)
}
